module.exports = __webpack_public_path__ + "img/gonggao.1575732d.png";